// extracted by mini-css-extract-plugin
module.exports = {"item":"DialogInstallInstructions_item__qcoNM","image":"DialogInstallInstructions_image__OkeV9"};